import { loadStripe, Stripe } from '@stripe/stripe-js';

// This singleton calls `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object more than once on a page.
// Requires this in the Rails HAML view:
// :javascript
//   globalThis.stripe_publishable_key = '#{STRIPE_PUBLIC_KEY}'
class StripeScriptLoader {
  private static privateInstance: StripeScriptLoader;

  public static get instance(): StripeScriptLoader {
    if (!StripeScriptLoader.privateInstance) {
      StripeScriptLoader.privateInstance = new StripeScriptLoader();
    }
    return StripeScriptLoader.privateInstance;
  }

  private privateStripePromise: Promise<Stripe>;

  private constructor() {
    // @ts-ignore
    this.privateStripePromise = loadStripe(globalThis.stripe_publishable_key);
  }

  get stripePromise(): Promise<Stripe | null> {
    return this.privateStripePromise;
  }
}

export default StripeScriptLoader;
